
import React from 'react';
import { AnalyticsDashboard } from '@/components/ai-assistant/management/AnalyticsDashboard';

const AiAssistantAnalyticsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">AI Analytics</h1>
        <p className="text-muted-foreground mt-1">Comprehensive insights and performance metrics</p>
      </div>
      
      <AnalyticsDashboard />
    </div>
  );
};

export default AiAssistantAnalyticsPage;
